import { render, staticRenderFns } from "./xinkuaijie.vue?vue&type=template&id=3291e606&scoped=true"
import script from "./xinkuaijie.vue?vue&type=script&lang=js"
export * from "./xinkuaijie.vue?vue&type=script&lang=js"
import style0 from "./xinkuaijie.vue?vue&type=style&index=0&id=3291e606&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3291e606",
  null
  
)

export default component.exports